export function getImageMeta(url) {
  return new Promise(function (resolve, reject) {
    var img = new Image();
    img.addEventListener("load", function () {
      resolve({
        width: this.naturalWidth,
        height: this.naturalHeight
      });
    });
    img.addEventListener("error", function () {
      reject();
    });
    img.src = url;
  });
}